import { ReactNode } from 'react';
import classnames from 'classnames';
import { ErrorMessage } from 'formik';
import Label from '../RawLabel';
import ContextualErrors from '../ContextualErrors';
import { useFormTheme } from '../ThemeContext';
import s from '../forms.module.less';

export type FieldWrapperProps = {
  description?: string;
  descriptionClass?: string;
  labelClass?: string;
  containerClass?: string;
  name: string;
  labelText?: ReactNode;
  children: ReactNode;
  required?: boolean;
  'data-testid'?: string;
};

const FieldWrapper = ({
  description,
  descriptionClass,
  name,
  labelClass,
  containerClass,
  labelText,
  required,
  children,
  'data-testid': dataTestId,
}: FieldWrapperProps) => {
  const layout = useFormTheme();
  return (
    <div
      className={classnames(s.container, layout === 'horizontal' && s.horizontal, containerClass)}
      data-testid={dataTestId}
    >
      {labelText ? (
        <Label
          name={name}
          className={classnames(layout === 'horizontal' && s.horizontalLabel, labelClass)}
          required={required}
          horizontal={layout === 'horizontal'}
        >
          {labelText}
        </Label>
      ) : null}
      <div className={s.inputWrapper}>{children}</div>
      {description ? (
        <span className={descriptionClass} id={`${name}-description`}>
          {description}
        </span>
      ) : null}
      <div id={`${name}-error`}>
        <ErrorMessage name={name}>
          {(messages: string | string[]) => <ContextualErrors messages={messages} />}
        </ErrorMessage>
      </div>
    </div>
  );
};
/* eslint-enable react/no-array-index-key */

export default FieldWrapper;
